// Cliente API del módulo de seguimiento — Django /admin/performance.
// Mismo patrón que galan-inbox/api.ts (proxy /django-api + Bearer).
// El aislamiento por atleta lo hace el backend: un atleta sólo recibe lo suyo.

import type { Athlete, PerformanceDashboard, SparringIn } from './types';

const DJANGO_PROXY = '/django-api';
const BASE = '/api/v1/admin/performance';

function authHeaders(): Record<string, string> {
  const token = localStorage.getItem('auth_token');
  return { Authorization: `Bearer ${token ?? ''}` };
}

async function asJson<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const body = await res.text();
    throw new Error(`${res.status} ${res.statusText} — ${body.slice(0, 200)}`);
  }
  return res.json() as Promise<T>;
}

export async function listAthletes(): Promise<Athlete[]> {
  return asJson(await fetch(`${DJANGO_PROXY}${BASE}/athletes`, { headers: authHeaders() }));
}

export async function getDashboard(athleteId?: string, days = 35): Promise<PerformanceDashboard> {
  const qs = new URLSearchParams({ days: String(days) });
  if (athleteId) qs.set('athlete_id', athleteId);
  return asJson(await fetch(`${DJANGO_PROXY}${BASE}/dashboard?${qs}`, { headers: authHeaders() }));
}

export async function logSparring(payload: SparringIn & { athlete_id?: string }): Promise<unknown> {
  const res = await fetch(`${DJANGO_PROXY}${BASE}/sparring`, {
    method: 'POST',
    headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return asJson(res);
}
